"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePagination = exports.range = exports.ellipses = void 0;

var _react = require("react");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ellipses = '...';
exports.ellipses = ellipses;

var range = function range(start, end) {
  var length = end - start + 1;
  return Array.from({
    length: length
  }, function (_, idx) {
    return idx + start;
  });
};

exports.range = range;

var usePagination = function usePagination(_ref) {
  var totalResults = _ref.totalResults,
      resultsPerPage = _ref.resultsPerPage,
      _ref$siblingCount = _ref.siblingCount,
      siblingCount = _ref$siblingCount === void 0 ? 1 : _ref$siblingCount,
      currentPage = _ref.currentPage;

  var _useState = (0, _react.useState)(function () {
    return [];
  }),
      _useState2 = _slicedToArray(_useState, 2),
      leftSkippedPages = _useState2[0],
      setLeftSkippedPages = _useState2[1];

  var _useState3 = (0, _react.useState)(function () {
    return [];
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      rightSkippedPages = _useState4[0],
      setRightSkippedPages = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      leftOnlySkippedPages = _useState6[0],
      setLeftOnlySkippedPages = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = _slicedToArray(_useState7, 2),
      rightOnlySkippedPages = _useState8[0],
      setRightOnlySkippedPages = _useState8[1];

  var paginationRange = (0, _react.useMemo)(function () {
    var totalPageCount = Math.ceil(totalResults / resultsPerPage); // Pages count is determined as siblingCount + firstPage + lastPage + currentPage + 2*ellipses

    var totalPageNumbers = siblingCount + 5;
    /*
      If the number of pages is less than the page numbers returns the range [1..totalPageCount]
    */

    if (totalPageNumbers >= totalPageCount) {
      return range(1, totalPageCount);
    }

    var leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    var rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
    /*
      We do not want to show dots if there is only one position left
      after/before the left/right page count as that would lead to a change if our Pagination
      component size which we do not want
    */

    var shouldShowLeftDots = leftSiblingIndex > 2;
    var shouldShowRightDots = rightSiblingIndex < totalPageCount - 2; // Get Skipped pages hidden by ellipses

    var firstPageIndex = 1;
    var lastPageIndex = totalPageCount;

    if (shouldShowLeftDots && !shouldShowRightDots) {
      var rightItemCount = 3 + 2 * siblingCount;
      var rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
      setLeftOnlySkippedPages([firstPageIndex + 1, totalPageCount - 5]);
      return [firstPageIndex, ellipses].concat(_toConsumableArray(rightRange));
    }

    if (!shouldShowLeftDots && shouldShowRightDots) {
      var leftItemCount = 3 + 2 * siblingCount;
      var leftRange = range(1, leftItemCount);
      setRightOnlySkippedPages([leftItemCount + 1, totalPageCount - 1]);
      return [].concat(_toConsumableArray(leftRange), [ellipses, totalPageCount]);
    }

    if (shouldShowLeftDots && shouldShowRightDots) {
      var middleRange = range(leftSiblingIndex, rightSiblingIndex);

      if (shouldShowLeftDots) {
        var value = range(2, leftSiblingIndex - 1);
        setLeftSkippedPages(value);
      }

      if (shouldShowRightDots) {
        var _value = range(rightSiblingIndex + 1, totalPageCount - 1);

        setRightSkippedPages(_value);
      }

      return [firstPageIndex, ellipses].concat(_toConsumableArray(middleRange), [ellipses, lastPageIndex]);
    }
  }, [totalResults, resultsPerPage, siblingCount, currentPage]);
  return {
    paginationRange: paginationRange,
    leftSkippedPages: leftSkippedPages,
    rightSkippedPages: rightSkippedPages,
    leftOnlySkippedPages: leftOnlySkippedPages,
    rightOnlySkippedPages: rightOnlySkippedPages
  };
};

exports.usePagination = usePagination;